var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center"},[_c('h2',[_vm._v("Treatment option overview")]),_c('div',{staticClass:"mt-8 text-left space-y-3",domProps:{"innerHTML":_vm._s(_vm.currentQuestion.noAnswerFeedback)}})])}
var staticRenderFns = []

export { render, staticRenderFns }